var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benchmark"},[_vm._v("benchmark here")])
}
var staticRenderFns = []

export { render, staticRenderFns }